import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=05c30ec4&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"
import style0 from "./Exam.vue?vue&type=style&index=0&id=05c30ec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c30ec4",
  null
  
)

export default component.exports